import { Component, ElementRef, Input, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from '@shared/component/layout/menu/menu-item';
import { VideoGalleryDialogComponent } from '@shared/component/video-gallery-dialog/video-gallery-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { User } from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';

/**
 * Component with header menu
 */
@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HeaderMenuComponent extends BaseComponent implements OnInit {
  private dialog = inject(MatDialog);

  @ViewChild('headerMenu') menuWrapper: ElementRef;
  @Input() items: MenuItem[];
  user: User;

  ngOnInit(): void {
    this.user = this.userService.getCacheFirst();
  }

  openCVideoPlayerDialogComponent(): void {
    this.dialog.open(VideoGalleryDialogComponent, {
      panelClass: ['dialog-medium', 'mobile-full-screen']
    });
  }
}
